<template>
  <div v-loading="loading">
    <el-card class="corporate-card-settings">
      <el-row>
        {{ $t('corporate_card') }}:
      </el-row>
      <el-row v-if="!!payoutCard">
        <el-col :md="3">
          <el-card
              class="corporate-card"
              bg-variant="info"
              text-variant="white"
              :header="payoutCard.blurredPan"
          ></el-card>
        </el-col>
      </el-row>
      <el-row>
        <el-form v-if="!!payoutCardFlowPayload" :action="payoutCardFlowUrl" method="post">
          <input type="hidden" name="wsb_store_id" :value="payoutCardFlowPayload.storeId">
          <input type="hidden" name="wsb_seed" :value="payoutCardFlowPayload.seed">
          <input type="hidden" name="wsb_signature" :value="payoutCardFlowPayload.signature">
          <input type="hidden" name="wsb_return_url" :value="payoutCardFlowPayload.returnUrl">
          <el-form-item>
            <el-button
                style="float:right"
                round
                native-type="submit"
                type="primary"
            >{{ $t("add") }}</el-button>
          </el-form-item>
        </el-form>
        <el-button
            v-if="!!payoutCard"
            style="float:right"
            round
            @click="removePayoutCard"
            type="danger"
        >{{ $t("remove") }}</el-button>
      </el-row>
    </el-card>
  </div>
</template>
<script>
export default {
  name: 'payouts',
  data: () => ({
    loading: true,
    headers: {
      'Authorization': `Bearer ${window.localStorage.getItem('jwt_token')}`,
      'Content-Type': 'application/json;charset=utf-8'
    },
    payoutSettingsUrl: `${process.env.VUE_APP_BILLING_API_URL}/v1/merchant/payout-settings`,
    removePayoutCardUrl: `${process.env.VUE_APP_BILLING_API_URL}/v1/merchant/payout-card/remove`,
    payoutCardFlowUrl: process.env.VUE_APP_PAYOUT_CARD_FLOW_URL,
    payoutCard: null,
    payoutCardFlowPayload: null
  }),
  created() {
    this.getPayoutSettingsApiRequest()
  },
  methods: {
    async getPayoutSettingsApiRequest() {
      this.loading = true
      this.payoutCard = null
      this.payoutCardFlowPayload = null

      const response = await fetch(this.payoutSettingsUrl, {
        method: 'GET',
        headers: this.headers
      })

      const responseData = await response.json().catch(() => {
        alert('Unexpected error.')
      })

      if (response.status === 200) {
        this.payoutCard = responseData.data.payoutCard
        this.payoutCardFlowPayload = responseData.data.payoutCardFlowPayload
      } else {
        alert('Unexpected error.')
      }

      this.loading = false
    },
    async removePayoutCardApiRequest() {
      this.loading = true

      const response = await fetch(this.removePayoutCardUrl, {
        method: 'POST',
        headers: this.headers
      })

      await response.json().catch(() => {
        alert('Unexpected error.')
      })

      if (response.status !== 200) {
        alert('Unexpected error.')
      }

      this.loading = false
    },
    async removePayoutCard() {
      await this.removePayoutCardApiRequest()
      await this.getPayoutSettingsApiRequest()
    }
  }
}
</script>
<style>
.corporate-card
{
  font-size: 0.8em;
  min-height: 90px;
  max-width: 180px;
}
.corporate-card .el-card__header
{
  min-height: 60px;
}
</style>
